<template>
  <div class="age-dropdown" v-show="elementActive">
    <div class="col-3 field-label">{{label}}</div>
    <div class="col-7 field-response">
        <select v-model="currentValue" class="form-select inner-select" :disabled="elementDisabled">
            <option :value="null" v-show="currentValueDefined">Please Select Age</option>
            <option :value="undefined" v-show="!currentValueDefined">Please Select Age</option>
            <option v-for="val in values" :value="val.value" :key="val.id">{{val.display}}</option>
        </select>
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'
import ProgramSpecificMixin from './ProgramSpecificMixin'

export default {
  name: 'AgeDropDown',
  mixins: [PropsMixin, ComputedMixin, ProgramSpecificMixin],
  data () {
    var ages = []
    for (let k = 17; k < 86; k++) {
      ages.push({
        display: `${k}`,
        value: k,
        id: k
      })
    }
    return {
      values: ages
    }
  },
  computed: {
  },
  mounted () {
  },
  watch: {
  }
}
</script>
